/* global SENTRY_PUBLIC_DSN, SENTRY_RELEASE */
import * as Sentry from '@sentry/browser';

import { dropNetworkErrors } from 'react/helpers/network_error';

if (SENTRY_PUBLIC_DSN && SENTRY_PUBLIC_DSN !== '') {
  Sentry.init({
    dsn: SENTRY_PUBLIC_DSN,
    environment: process.env.NODE_ENV,
    release: SENTRY_RELEASE || undefined,
    // A learner on a dropped connection is telemetry, not a defect (#8033).
    beforeSend: dropNetworkErrors,
  });

  if (typeof window !== 'undefined' && window.SENTRY_CONTEXT) {
    const context = window.SENTRY_CONTEXT;

    if (context.user) {
      Sentry.setUser({ id: context.user.id, email: context.user.email });
    }

    if (context.tags) {
      Sentry.setTags(context.tags);
    }
  }
}
